import Swiper, {Pagination, Navigation, Autoplay} from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);
import MicroModal from 'micromodal';

export namespace VideoSlider {

	let setupSlider = () => {
		let videoSliders = document.querySelectorAll('.js-video-slider');

		//For Each Video Slider Loop through and setup swiper
		videoSliders.forEach((slider, index) => {

			let links = slider.querySelectorAll('.js-video-slider-play');

			links.forEach((link) => {
				link.addEventListener('click', (e) => {
					e.preventDefault();

					let linkYoutubeID = link.getAttribute('data-youtubeid');
					let youtubeUrl = `https://www.youtube.com/embed/${linkYoutubeID}?modestbranding=1&rel=0`
					let modalIframe = document.querySelector('.modal__iframe-grid');

					modalIframe.setAttribute('src', youtubeUrl);

					MicroModal.show('modal-video-carousel', {
						// look to see if we have a custom mp4 player on the page
						// since they are often shown together
						// be sure to pause all if we find any
						onShow: function(){
							let mp4Player = document.querySelectorAll('.js-custom-video-player');
							if (mp4Player){
								mp4Player.forEach((player:HTMLDivElement) => {
									let video = player.querySelector('video');
									let playButton = player.querySelector('.js-custom-video-play');
									video.pause();
									playButton.classList.remove('hide');
								})
							}
						},
						onClose: function() {
							modalIframe.setAttribute('src', '');
						},
					});
				});
			});

			slider.classList.add(`video-slider__swiper--${index}`);
			// Set desktopSlidesPerView based on number of .swiper-slide elements
			let desktopSlidesPerView = 3;
			const slideCount = slider.querySelectorAll('.swiper-slide').length;
			if (slideCount >= 4) {
				desktopSlidesPerView = 4;
			}
			const swiper = new Swiper(`.video-slider__swiper--${index}`, {
				spaceBetween: 0,
				initialSlide: 0,
				breakpoints: {
					0: {
						slidesPerView: 1
					},
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1028: {
                        slidesPerView: desktopSlidesPerView,
                        spaceBetween: 20,

                    }
				},
				pagination: {
				 	el: `.swiper-pagination`,
				 	clickable: true
				 },
				navigation: {
					nextEl: `.swiper-button-next`,
					prevEl: `.swiper-button-prev`,
				},
			});
		});
	}

	export const init = () => {
		setupSlider();
	}
}

document.addEventListener('DOMContentLoaded', VideoSlider.init);
